import React from 'react'
import './Inline.scss'

import icon_up from '../../i/up.svg'
import icon_down from '../../i/down.svg'
import icon_delete from '../../i/delete.svg'

const CONTROLS = [
    { icon: icon_up, action: 'up' },
    { icon: icon_down, action: 'down' },
    { icon: icon_delete, action: 'delete' },
]

class InlineControls extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    onClick(c) {
        const { onAction, blockId } = this.props
        onAction({ ...c, blockId })
    }

    render() {
        return (
            <div className="inline-ctr-panel">
                {CONTROLS.map((c, i) => (
                    <div key={i} className="inline-ctr" onClick={this.onClick.bind(this, c)}>
                        <div className="img_wr">
                            <img src={c.icon}></img>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}

export default InlineControls
